import { Asset } from 'contentful';
import Image from 'next/image';
import Link from 'next/link';

type Props = {
  topTitle: string;
  title: string;
  subtitle: string;
  button1Text: string;
  button1Link: string;
  button2Text: string;
  button2Link: string;
  image: Asset;
};

export default function Hero({
  topTitle,
  title,
  subtitle,
  button1Text,
  button1Link,
  button2Text,
  button2Link,
  image,
}: Props) {
  return (
    <section className="bg-white">
      <div className="mx-auto mt-4 flex max-w-7xl px-6 pb-16 pt-32">
        <div className="flex-[2]">
          <h1 className="text-center text-2xl uppercase lg:text-left">
            {topTitle}
          </h1>
          <h2 className="text-r-5xl my-8 text-center font-bold leading-[3.5rem] lg:max-w-2xl lg:text-left ">
            {title}
          </h2>
          <p className="text-r-2xl mb-8 text-center text-black  lg:max-w-lg lg:text-left">
            {subtitle}
          </p>
          <div className="flex items-center flex-col sm:flex-row justify-center gap-4 lg:justify-start">
            <Link
              href={button1Link}
              target="_blank"
              rel="noreferrer noopener"
              passHref
            >
              <a className="btn-primary">{button1Text}</a>
            </Link>

            <Link href={button2Link} passHref>
              <a className="btn-secondary text-primary hover:text-white">
                {button2Text}
              </a>
            </Link>
          </div>
        </div>
        <div className="hidden lg:flex">
          <div className="mt-4 -mr-12 flex flex-1 items-center justify-center">
            <Image
              src={`https://${image.fields.file.url}`}
              width="600"
              height="445"
              alt={title}
              priority
              unoptimized
            />
          </div>
        </div>
      </div>
    </section>
  );
}
